var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', [_c('Input', {
    attrs: {
      "placeholder": $t("3qpvsa5", "输入关键字"),
      "suffix": "ios-search",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onChangeSearch
    },
    model: {
      value: _vm.search.value,
      callback: function ($$v) {
        _vm.$set(_vm.search, "value", $$v);
      },
      expression: "search.value"
    }
  })], 1), _c('div', {
    staticClass: "pt-[10px] pb-[10px]"
  }, [_c('Tree', {
    attrs: {
      "data": _vm._treeData,
      "render": _vm.renderContent
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };